import { ForkJoinObservable } from './ForkJoinObservable';
export var forkJoin = ForkJoinObservable.create;
//# sourceMappingURL=forkJoin.js.map